import { type Inventory } from 'src/types'

const defaultInventory: Inventory = {
  bag: {},
  equipped: {
    head: 'headlamp',
    chest: '',
    hands: '',
    feet: '',
    bag: ''
  },
  stats: {
    bag_slots: 2,
    bag_slots_max: 20,
    kg: 0,
    kg_max: 10,
    attack_bonus: 0,
    armor_bonus: 0,
    player_str: 0,
    player_dex: 0,
    player_vit: 0,
    player_hp: 0,
    player_ap: 0,
    light_radius: 0
  },
  stash: {},
  loot: {}
}

export {
  defaultInventory
}
